export const formatToUppercase = value =>
  value ? value.toUpperCase() : undefined;

export const formatToLowerCase = value => value.toLowerCase();

export const formatTrimWhiteSpace = value =>
  !value ? value.trim() : undefined;

export const ArrayFormat = (values) =>
  Array.isArray(values) ? values.join(' | ') : values;


// WEBPACK FOOTER //
// ./src/utils/formats.js